import { getAuthHeaders } from './authActions'

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

export const getExperiencePositions = async (experienceSlug) => {
	const res = await fetch(
		`${BASE_URL}/api/experiences/${experienceSlug}/positions`,
		{
			headers: { ...getAuthHeaders() },
		}
	)
	if (!res.ok) throw new Error('Failed to fetch positions')
	return res.json()
}

export const getExperiencePosition = async (experienceSlug) => {
	const res = await fetch(
		`${BASE_URL}/api/experiences/${experienceSlug}/position`,
		{
			headers: { ...getAuthHeaders() },
		}
	)

	if (!res.ok) throw new Error('Failed to fetch user position')
	return res.json()
}

export const updateStaffPosition = async (
	positionId,
	{ level, station, positionName }
) => {
	const res = await fetch(
		`${BASE_URL}/api/experiences/positions/${positionId}`,
		{
			method: 'PATCH',
			headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
			body: JSON.stringify({ level, station, positionName }),
		}
	)
	if (!res.ok) throw new Error('Failed to update position')
	return res.json()
}

export const addStaffPosition = async ({
	userId,
	experienceSlug,
	level,
	station,
	positionName,
}) => {
	const res = await fetch(
		`${BASE_URL}/api/experiences/${experienceSlug}/positions`,
		{
			method: 'POST',
			headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
			body: JSON.stringify({ userId, level, station, positionName }),
		}
	)
	if (!res.ok) throw new Error('Failed to add position')
	return res.json()
}

export const createExperience = async ({ orgId, name, slug }) => {
	const res = await fetch(`${BASE_URL}/api/experiences`, {
		method: 'POST',
		headers: {
			...getAuthHeaders(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ orgId, name, slug }),
	})

	if (!res.ok) throw new Error('Failed to create experience')

	return res.json()
}

export const getExperience = async (experienceSlug) => {
	const res = await fetch(`${BASE_URL}/api/experiences/${experienceSlug}`, {
		headers: getAuthHeaders(),
	})
	if (!res.ok) throw new Error('Failed to fetch experience')
	return res.json()
}

export const getItemOptions = async (experienceSlug) => {
	const res = await fetch(
		`${BASE_URL}/api/experiences/${experienceSlug}/item-options`,
		{
			headers: getAuthHeaders(),
		}
	)
	if (!res.ok) throw new Error('Failed to fetch item options')
	return res.json()
}

export const getStationOptions = async (experienceSlug) => {
	const res = await fetch(
		`${BASE_URL}/api/experiences/${experienceSlug}/station-options`,
		{
			headers: getAuthHeaders(),
		}
	)
	if (!res.ok) throw new Error('Failed to fetch station options')
	return res.json()
}

export const updateExperience = async (experienceSlug, data) => {
	const res = await fetch(`${BASE_URL}/api/experiences/${experienceSlug}`, {
		method: 'PATCH',
		headers: {
			...getAuthHeaders(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})
	if (!res.ok) throw new Error('Failed to update experience')
	return res.json()
}

export const addItemOption = async (experienceSlug, data) => {
	const res = await fetch(
		`${BASE_URL}/api/experiences/${experienceSlug}/item-options`,
		{
			method: 'POST',
			headers: {
				...getAuthHeaders(),
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		}
	)
	if (!res.ok) throw new Error('Failed to create item option')
	return res.json()
}

export const updateItemOption = async (experienceSlug, itemId, data) => {
	const res = await fetch(
		`${BASE_URL}/api/experiences/${experienceSlug}/item-options/${itemId}`,
		{
			method: 'PATCH',
			headers: {
				...getAuthHeaders(),
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		}
	)
	if (!res.ok) throw new Error('Failed to update item option')
	return res.json()
}

export const deleteItemOption = async (experienceSlug, itemId) => {
	const res = await fetch(
		`${BASE_URL}/api/experiences/${experienceSlug}/item-options/${itemId}`,
		{
			method: 'DELETE',
			headers: getAuthHeaders(),
		}
	)
	if (!res.ok) throw new Error('Failed to delete item option')
	return res.json()
}

export const addStationOption = async (experienceSlug, name) => {
	const res = await fetch(
		`${BASE_URL}/api/experiences/${experienceSlug}/station-options`,
		{
			method: 'POST',
			headers: {
				...getAuthHeaders(),
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ name }),
		}
	)
	if (!res.ok) throw new Error('Failed to create station option')
	return res.json()
}

export const deleteStaffPosition = async (positionId) => {
	const res = await fetch(
		`${BASE_URL}/api/experiences/positions/${positionId}`,
		{
			method: 'DELETE',
			headers: getAuthHeaders(),
		}
	)
	if (!res.ok) throw new Error('Failed to delete staff position')
	return res.json()
}

export const getExperienceStats = async (experienceSlug) => {
	try {
		const res = await fetch(
			`${BASE_URL}/api/experiences/${experienceSlug}/stats`,
			{
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					...getAuthHeaders(),
				},
			}
		)

		if (!res.ok) {
			throw new Error(`Failed to fetch stats: ${res.status}`)
		}

		const data = await res.json()
		return data
	} catch (err) {
		console.error('❌ Error in getExperienceStats:', err)
		throw err
	}
}
